var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2291 1.9458H9.33865C4.9809 1.9458 1.44824 5.47846 1.44824 9.83621V17.7266C1.44824 22.0844 4.9809 25.617 9.33865 25.617H17.2291C21.5868 25.617 25.1195 22.0844 25.1195 17.7266V9.83621C25.1195 5.47846 21.5868 1.9458 17.2291 1.9458Z",
    stroke: "#3D4910",
    strokeWidth: 2.63014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2842 19.042C16.1894 19.042 18.5445 16.6869 18.5445 13.7818C18.5445 10.8766 16.1894 8.52148 13.2842 8.52148C10.379 8.52148 8.02393 10.8766 8.02393 13.7818C8.02393 16.6869 10.379 19.042 13.2842 19.042Z",
    stroke: "#3D4910",
    strokeWidth: 2.63014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8597 8.37721C20.586 8.37721 21.1748 7.78843 21.1748 7.06214C21.1748 6.33585 20.586 5.74707 19.8597 5.74707C19.1335 5.74707 18.5447 6.33585 18.5447 7.06214C18.5447 7.78843 19.1335 8.37721 19.8597 8.37721Z",
    fill: "#3D4910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c4a5f2ff09c7e8d713518939c9a27cb6.svg";
export { ForwardRef as ReactComponent };